import React from 'react'
import Step1 from '../Image/Step1.webp'
// import Step1 from '../Image/Step1.svg'
import CA_form_page from './CA_form_page'
function CA_forth_comp() {
  return (
    <div>
      {/* -----------------Mobile View---------------------- */}
      <div className='container d-sm-block d-md-none'>
      <div>
      <h2 className='text-center mobile_CA_second_comp_txt'>Application Process</h2>
      </div>
      <div className='row mt-4'>
        <div className='container'>
            <div className='row text-center CA_Forth_comp_line_mobile'>
            <div className='col-12'>
                <span className=' fs-6 text-danger fw-bold'>Fill your Application</span>
                <p>Apply quickly in 2 minutes</p>
            </div>
            <div className='col-12 py-2'>
                <span className='fs-6 fw-bold text-warning'>Telephonic interview</span>
                <p>Connect with InternsElite team</p>
            </div>
            <div className='col-12'>
                <span className='fs-6 fw-bold text-success'>Do Short Task</span>
                <p>Get yourself onboarded</p>
            </div>
            <div className='col-12 py-2'>
                <span className='fs-6 fw-bold text-info'>Start your journey</span>
                <p>Way to learning and rewards</p>
            </div>
            </div>
        </div>
      </div>
      <div className='row'>
            <div className='col-12'>
                <div><CA_form_page/></div>
            </div>
        </div>
      </div>
      
      

      {/* ---------------------------Desktop view-------------------- */}
      <div className='container d-none d-md-block'>
      <div className='row'>
        <div className='col-md-2'></div>
        <div className='col-md-8'>
            <div>
            <h2 className='text-center CA_second_comp_txt display-5'>Application Process</h2>
            </div>
        </div>
        <div className='col-md-2'></div>
      </div>
      <div className=''>
      <div className='row pt-5 CA_Forth_comp_line'>
        <div className='col-md-3'>
        <div className='text-center'>
            <span className='fs-5 text-danger fw-bold'>Fill your Application</span>
            <p>Apply quickly in 2 minutes</p>
        </div>
        </div>
        <div className='col-md-3'>
        <div className='text-center'>
            <span className='fs-5 fw-bold text-warning'>Telephonic interview</span>
            <p>Connect with Internselite team</p>
        </div>
        </div>
        <div className='col-md-3'>
        <div className='text-center'>
            <span className='fs-5 fw-bold text-success'>Do Short Task </span>
            <p>Get yourself onboarded</p>
        </div>
        </div>
        <div className='col-md-3'>
        <div className='text-center'>
            <span className='fs-5 fw-bold text-info'>Start your journey</span>
            <p>Way to learning and rewards</p>
        </div>
        </div>

        <div className='row mt-4'>
            <div className='col-md-7'>
                <div className='pt-5'>
                    <img className='mt-2 CA_Forth_background_img ' src={Step1} onContextMenu={(e) => e.preventDefault()}></img>
                </div>
            </div>
            <div className='col-md-5'>
                <div><CA_form_page/></div>
            </div>
        </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default CA_forth_comp
